import { IComponentSource, ComponentModel, MarkdownComponent } from "./core";

export interface IHorizontalRuleComponentModel extends IComponentSource {
  isThick: boolean;
}

class HorizontalRuleComponentModel extends ComponentModel implements IHorizontalRuleComponentModel {
  public isThick: boolean = false;
}

export const buildHorizontalRuleComponentModel = (source: IComponentSource) => {
  const ruleComponent = new HorizontalRuleComponentModel(source);
  ruleComponent.isThick = source.type === MarkdownComponent.ThickRule;
  
  return ruleComponent;
}